module.exports = __webpack_public_path__ + "img/hdmd3.290882a6.jpg";